import {Directions} from '@jetbrains/ring-ui/components/popup/popup.consts'
import * as React from 'react'

import BuildsFetcher from '../../../../../containers/BuildsFetcher'
import BuildInfo from '../../../../common/BuildInfo/BuildInfo.container'
import BuildsTimeline from '../../../../common/BuildsTimeline/BuildsTimeline.container'
import Popup from '../../../../common/Popup/Popup.lazy'

import type {InnerProps} from './BuildTypeInfoPopup.types'

export const TIMELINE_STAT_COUNT = 15

function BuildTypeInfoPopup({
  className,
  locator,
  buildId,
  buildTypeId,
  hoveredBuildId,
  selectedBuildId,
  hover,
  selectBuild,
  hoverBuild,
  measureRef,
  handleMouseEnter,
  handleHoverBuild,
  handleMouseLeave,
  handleMouseMove,
  loading,
  buildsKey,
}: InnerProps) {
  const [renderedBuildsFetcher, setRenderedBuildsFetcher] = React.useState<boolean | null>(null)
  React.useEffect(
    () => () => {
      selectBuild?.(null)
      hoverBuild?.(null)
    },
    [selectBuild, hoverBuild],
  )
  React.useEffect(() => {
    if (renderedBuildsFetcher !== true && hover) {
      setRenderedBuildsFetcher(true)
    }
  }, [hover, renderedBuildsFetcher, setRenderedBuildsFetcher])
  const displayedBuildId = hoveredBuildId ?? selectedBuildId
  return (
    <div
      className={className}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseMove={handleMouseMove}
      data-test="buildtype-info-popup"
      data-buildtype-id={buildTypeId}
    >
      <BuildsTimeline
        buildsKey={buildsKey}
        loading={loading}
        statCount={TIMELINE_STAT_COUNT}
        currentBuildId={buildId}
        hoveredBuildId={hoveredBuildId}
        hoverBuild={handleHoverBuild}
        selectBuild={selectBuild}
        withSaveQueryParams
        withPreviousNextButton
        withHighLightCurrentBuild
        aroundBuild={buildId}
      />
      {renderedBuildsFetcher === true && (
        <BuildsFetcher locator={locator} buildTypeId={buildTypeId} withRunning withQueued />
      )}
      {displayedBuildId != null && (
        <Popup directions={[Directions.BOTTOM_LEFT, Directions.BOTTOM_CENTER]}>
          <BuildInfo key={displayedBuildId} elementRef={measureRef} buildId={displayedBuildId} />
        </Popup>
      )}
    </div>
  )
}

export default React.memo<InnerProps>(BuildTypeInfoPopup)
